<template>
    <div class="dashboard-chart-card mr-1">
        <div class="d-flex justify-content-center mb-3 mt-3 pt-3 pb-3" v-if="is_load">
            <b-spinner variant="success" label="Loading..."></b-spinner>
        </div>

        <div class="chart" v-else>
            <highcharts :options="chartOptions" :highcharts="char3d"></highcharts>
        </div>
    </div>
</template>

<script>
    import {Chart} from 'highcharts-vue';
    import Highcharts3D from 'highcharts/highcharts-3d';
    import Highcharts from 'highcharts';

    Highcharts3D(Highcharts);
    export default {
        name: "bank",

        props: {
            id: {
                type: Number,
                require: false,
            },

            cur_type  : {
                type: String,
                default:"counts"
            },

            month: {
                type: String,
                default:""
            },

        },

        components: {
            highcharts: Chart
        },


        created () {
          EventBus.$on('change_date',res => {
            this.getStat();
          }) ;
        },

        mounted() {
            this.getStat();
        },

        data() {
            return {
                is_load: true,
                char3d : Highcharts,
                chartOptions: {
                    chart: {
                        type: 'column',
                        options3d: {
                            enabled: true,
                            alpha: 0,
                            beta: 20,
                            depth: 80
                        }
                    },
                    yAxis: {
                        title: {
                            text: ' '
                        },
                        gridLineColor: '#f1f2f7'
                    },



                    plotOptions: {
                        series: {
                            borderWidth: 0,
                            borderRadius: 4,
                            dataLabels: {
                                enabled: true,
                                format: '{point.y:.0f}'
                            }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        lineColor: '#eef0f5'
                    },

                    title:
                    {
                        text: this.__t('ALL_ORDER'),
                        align: 'left',
                        style:
                            {
                                color: '#3b3f5c',
                                fontSize: '15px',
                                fontWeight: '600',
                            }
                        //x: -20 //center
                    },
                    series: [{
                        colorByPoint: false,
                        showInLegend: false,
                        name : ' шт ',
                        data: []
                    }],
                    credits: {
                        enabled: false
                    },
                },
            }
        },


        methods: {
            async getStat() {
                this.is_load = true;

                await api.post('/internal/user/dashboard/bank', qs.stringify({
                        'stat_type':'bank',
                        'date':this.dash_param_date,
                    })

                ).then(({data}) => {

                    if (data.status == "operation_success") {
                        this.chartOptions.series[0].data = data.data.series;
                      //  console.log('bank_serias',data.data.series);
                        this.is_load = false;
                    }

                }).catch(err => {
                    this.is_load = true;
                    console.log(err);
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            },

        },
        computed: {

            dash_param_date() {
                return this.$store.state.dashboard.main.date;
            },

        },

    }
</script>

<style scoped>

</style>
